import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=8e9da90e&"
import script from "./LightBox.vue?vue&type=script&lang=js&"
export * from "./LightBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LightBox.vue"
export default component.exports